<template>
  <div class="modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal-inner" :style="{alignItems: 'flex-start'}">
      <div class="edit-popup edit-popup--invoice-total-amount">
        <div class="edit-popup__header edit-popup__header-invoice-total-amount">
          <div class="edit-popup__title">
            <span>Total Amount: </span>
            <span> {{getCurrencySign(currentInvoice.currencyType)}} {{numberWithCommas(currentInvoice.totalAmountPayable)}}</span>
          </div>
          <div class="edit-popup__close" @click="closeModal">
            <svg width="1em" height="1em" class="icon icon-close">
              <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
            </svg>
          </div>
        </div>
        <div class="invoice-total-amount__body">
          <div class="invoice-total-amount__list">
            <div class="invoice-total-amount__item" v-for="service in currentInvoice.services" :key="service.id">
              <div class="item__name" v-if="service.type === 'CUSTOM' || service.type === 'ADDITIONAL_OPTION'">
                <svg
                     width="20px"
                     height="20px"
                     class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#custom"></use></svg
                >
                <span>Custom</span>
              </div>
              <div class="item__name" v-if="service.type === 'OTHER_EXPENSES' || service.type === 'ADDITIONAL_SERVICE'">
                <svg
                     width="20px"
                     height="20px"
                     class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#other"></use></svg
                >
                <span>Other</span>
              </div>
              <div class="item__name" v-if="service.type === 'AIRPORT_VIP_SERVICE'">
                <svg
                     width="20px"
                     height="20px"
                     class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#airport-services"></use></svg
                >
                <span>Airport</span>
              </div>
              <div class="item__name" v-if="service.type === 'TRANSFER'">
                <svg v-if="service.type === 'TRANSFER'"
                     width="20px"
                     height="20px"
                     class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#transfers"></use></svg
                >
                <span>Transfer</span>
              </div>
              <div class="item__name" v-if="service.type === 'FLIGHT'">
                <svg
                     width="20px"
                     height="20px"
                     class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#flight-tickets"></use></svg
                >
                <span>Flight</span>
              </div>
              <div class="item__name" v-if="service.type === 'MAINLAND'">
                <svg
                     width="20px"
                     height="20px"
                     class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#day-trip"></use></svg
                >
                <span>Day Trip</span>
              </div>
              <div class="item__name" v-if="service.type === 'ISLAND' || service.type === 'ISLAND_TRANSFER' || service.type === 'ISLAND_DAY_TRIP'">
                <svg
                     width="20px"
                     height="20px"
                     class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#island"></use></svg
                >
                <span>Island</span>
              </div>
              <div class="item__name" v-if="service.type === 'SAFARI' || service.type === 'SAFARI_ACTIVITY'">
                <svg
                     width="20px"
                     height="20px"
                     class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#safari"></use></svg
                >
                <span>Safari</span>
              </div>
              <div class="item__name" v-if="service.type === 'CLIMBING' || service.type === 'CLIMBING_RENTAL' || service.type === 'CLIMBING_EXTRA'">
                <svg
                     width="20px"
                     height="20px"
                     class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing"></use></svg
                >
                <span>Climbing</span>
              </div>
              <div class="item__name" v-if="service.type === 'EXTRA_ACCOMMODATION'">
                <svg
                     width="20px"
                     height="20px"
                     class="icon icon-categories">
                  <use
                      xlink:href="/images/icons/invoices/invoices-sprite.svg#extra-accommodation"></use></svg
                >
                <span>Extra Accommodation</span>
              </div>
              <div class="item_total">
                <span>{{getCurrencySign(currentInvoice.currencyType)}} {{numberWithCommas(service.amountPayable)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCurrencySign} from '../../../common/helpers/currency'

export default {
  name: 'AtModalInvoiceTotalAmount',
  props: {
    currentInvoice: {
      type: Object,
      require: true
    }
  },
  methods: {
    getCurrencySign,
    closeModal() {
      this.$emit('closeModalInvoiceTotalAmountParams', false)
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  }
}
</script>

<style lang="scss">
.edit-popup--invoice-total-amount {
  width: 430px;
  padding: 39px;

  .edit-popup__title {
    span {
      font-weight: 600;
      font-size: 17px;
      line-height: 20px;
      text-transform: capitalize;

      color: #2E2E2E;
    }
  }

  .invoice-total-amount__body {
    padding-top: 20px;

    .invoice-total-amount__list {
      .invoice-total-amount__item {
        display: flex;
        align-items: center;
        justify-content: space-between;

        padding: 15px 0;

        border-top: 1px solid #EAEAEA;

        &:last-child {
          border-bottom: 1px solid #EAEAEA;
        }

        .item__name {
          display: flex;
          align-items: center;
          svg {
            width: 20px;
            height: 20px;
          }
          span {
            padding-left: 7px;

            display: block;

            font-weight: 500;
            font-size: 14px;
            line-height: 17px;

            color: #2E2E2E;
          }
        }
        .item_total {
          span {
            font-weight: 500;
            font-size: 14px;
            line-height: 17px;
            text-align: right;

            color: #2E2E2E;
          }
        }
      }
    }
  }
}
</style>
